// Helpers to map AFIP alícuota codes to percentages and decide whether to discriminar IVA
export function getAlicuotaPercent(code) {
  const c = Number(code);
  switch (c) {
    case 5:
      return 21;
    case 3:
      return 10.5;
    case 4:
      return 27; // example mapping if needed
    case 0:
      return 0;
    default:
      return 21; // default to 21%
  }
}

export function shouldDiscriminateIVA(fiscalInput) {
  // Tolerar null/undefined: el parámetro por defecto no cubre "null"
  const fiscal = (fiscalInput && typeof fiscalInput === 'object') ? fiscalInput : {};

  // Preferir campos explícitos si existen
  const condVal = fiscal.condicionIVA ?? fiscal.condicion ?? fiscal.tipoResponsable;
  if (typeof condVal !== 'undefined' && condVal !== null && condVal !== '') {
    const cond = Number(condVal);
    // 1 => Responsable Inscripto (discrimina)
    return cond === 1;
  }

  // Fallback: si hay flag booleano explícito, usarlo
  if (typeof fiscal.discriminarIVA !== 'undefined') return Boolean(fiscal.discriminarIVA);

  // Por defecto: asumir que discrimina (comportamiento previo)
  return true;
}

const taxUtils = { getAlicuotaPercent, shouldDiscriminateIVA };
export default taxUtils;
